
import { Options, Vue } from 'vue-class-component'
import MessageWindow from './MessageWindow.vue'
import NotepadWindow from './NotepadWindow.vue'

@Options({
    components: {
        MessageWindow,
        NotepadWindow,
    },
    data: () => ({
        currentWindow: 0,
        zIndex: 1,
    }),
    methods: {
        switchIndex: function (index: number) {
            this.zIndex = index
        },
    },
})
export default class MainWindow extends Vue {}
